module.exports = __webpack_public_path__ + "static/img/advantage1.a35ea92a.png";